export default {
	search,
};

function normalize(val: string) {
	return val.normalize('NFD').toUpperCase().replace(/[\u0300-\u036f]/g, '').replace(/[.-]/g, '');
}

function search(originalString, query) {
	const normalizedOriginal = normalize(originalString);
	const normalizedQuery = normalize(query);

	if (normalizedQuery.indexOf(' ') > -1) {
		const queryArr = normalizedQuery.split(' ');
		let result = true;

		for (const q of queryArr) {
			if (q) {
				if (normalizedOriginal.indexOf(q) === -1) {
					result = false;
					break;
				}
			}
		}

		return result;
	}

	return normalizedOriginal.indexOf(normalizedQuery) > -1;
}
